<template>
  <div class="activity-supplement-container">
    <section class="profit-overview">
      <div class="main-panel">
        <ProfitTable style="width: 100%">
          <tbody>
            <tr>
              <th>月份</th>
              <th>补款金额</th>
            </tr>
            <tr
              v-for="repairInfo in repairInfoList"
              :key="repairInfo.date"
            >
              <td class="poi-name">
                {{ repairInfo.date }}
              </td>
              <td>
                {{ repairInfo.repair }}元
              </td>
            </tr>
          </tbody>
        </ProfitTable>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ProfitTable from '@/components/ProfitTable';

export default {
  name: 'ActivitySupplement',
  components: {
    ProfitTable,
  },
  computed: {
    ...mapState(['repairInfoList']),
  },
};
</script>

<style lang="scss" scoped>
@import '../assets/css/mixin';
.activity-supplement-container {
   .profit-overview {
    background: #fff;
    margin: 18px;
    padding: 30px 0 36px 36px;
    border-radius: 12px;
    .main-panel {
      margin-top: 24px;
      padding-right: 36px;
    }

  }
}
</style>
